<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>报表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>钱包对账表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">交易日期</span>
        <el-date-picker
          v-model="searchOpts.beginDate"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          placeholder="选择开始日期"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="searchOpts.endDate"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          placeholder="选择结束日期"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" v-if="signedChannelDesc">
        <span class="demonstration">账户体系</span>
        <el-input v-model="signedChannelDesc" style="width: 280px" disabled></el-input>
      </div>
      <div class="toolbar-item" v-if="taxCompanyName">
        <span class="demonstration">承运公司</span>
        <el-input v-model="taxCompanyName" style="width: 280px" disabled></el-input>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="screenList" id="auto-1">筛选</el-button>
      </div>
    </div>

    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 钱包对账表 </span>
      </div>
      <div class="fr">
        <el-button
          type="primary"
          size="small"
          @click="exportList"
          v-if="roleRules.indexOf('SJB_P_0016') != -1"
          id="auto-2"
          >导出表格</el-button
        >
        <el-button icon="el-icon-info" @click="viewReportTips" id="auto-3">报表说明</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-4">
      <div class="mb-10">
        <report-tips></report-tips>
      </div>
      <el-table :data="tableData.data" border>
        <el-table-column prop="transTime" label="日期" width="90"> </el-table-column>
        <el-table-column prop="initialUsableAmt" label="期初可用余额" width="140"> </el-table-column>
        <el-table-column prop="initialFrzAmt" label="期初冻结" width="140"> </el-table-column>
        <el-table-column prop="initialPrePayAmt" label="期初预付" width="140"> </el-table-column>
        <el-table-column prop="dayRechargeAmt" label="当日充值" width="140"> </el-table-column>
        <el-table-column prop="dayFrzAmt" label="当日冻结" width="140"> </el-table-column>
        <el-table-column prop="dayThawAmt" label="当日解冻" width="140"> </el-table-column>
        <el-table-column prop="dayPrepayAmt" label="当日预付" width="140"> </el-table-column>
        <el-table-column prop="prePayBalance" label="当日预付结算" width="140"> </el-table-column>
        <el-table-column prop="dayActualAmt" label="当日实付运费" width="140"> </el-table-column>
        <el-table-column prop="cargoGuaranteePrice" label="当日货保费用(补充运费)" width="180"> </el-table-column>
        <el-table-column prop="returnCargoGuaranteePrice" label="当日货保退款费用(补充运费)" width="200">
        </el-table-column>
        <el-table-column prop="dayDispatAmt" label="当日实付调度费" width="140"> </el-table-column>
        <el-table-column prop="dayServiceAmt" label="当日实付服务费" width="140"> </el-table-column>
        <el-table-column prop="payFixCharge" label="当日实付撮合服务费" width="150"> </el-table-column>
        <el-table-column prop="payFixDeposit" label="当日预付保证金" width="140"> </el-table-column>
        <el-table-column prop="repayFixDeposit" label="当日退款保证金费用" width="150"> </el-table-column>
        <el-table-column prop="dayPayOther" label="当日实付其他" width="140"> </el-table-column>
        <el-table-column prop="prePayRefund" label="当日预付退款" width="140"> </el-table-column>
        <el-table-column prop="preferentialDispatAmt" label="调度费优惠汇总" width="140"> </el-table-column>
        <el-table-column prop="lastUsableAmt" label="期末可用余额" width="140"> </el-table-column>
        <el-table-column prop="lastFrzAmt" label="期末冻结" width="140"> </el-table-column>
        <el-table-column prop="lastPrePayAmt" label="期末预付" width="140"> </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="提示" :close-on-click-modal="false" custom-class="dia-tiny">
      <div class="text-c font-size16 mb-5">是否确认导出以下时段的查询结果？</div>
      <div class="text-c font-size14">
        开始时间：
        <span class="font-orange">{{ searchCache.beginDate | stamp2TextDateFull }}</span>
      </div>
      <div class="text-c font-size14">
        结束时间：
        <span class="font-orange">{{ searchCache.endDate | stamp2TextDateFull }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportComfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/report.new.api';
import { WUYI, vali } from '@/api/common';
import ymPageData from '@/utils/ymPageData';
export default {
  data: function () {
    return {
      pageSource: 'WalletReconciliation',
      pageSize: 20,
      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now() - 8.64e7) return true;
          return false;
        }
      },
      timeRange: [WUYI.time.timeend - 8.64e7, WUYI.time.timeend - 8.64e7], // 默认显示前一天的数据
      searchOpts: {
        //保存数据
        beginDate: WUYI.time.timeend - 8.64e7,
        endDate: WUYI.time.timeend - 8.64e7,
        taxChlType: null, // 总账户渠道
        chlType: '', // 签约渠道
        taxCompanyId: '' // 承运公司id
      },
      tableData: {
        total: 0,
        data: []
      },
      currentPage: 1,
      searchCache: {},
      dialogVisible: false,
      roleRules: '',
      signedChannelDesc: '',
      taxCompanyName: ''
    };
  },
  created() {
    this.roleRules = WUYI.currentData.userrole;
    this.searchOpts.chlType = this.$route.params.chlType || '';
    this.searchOpts.taxChlType = this.$route.params.taxChlType || null;
    this.searchOpts.taxCompanyId = this.$route.params.taxCompanyId || '';
    this.signedChannelDesc = this.$route.query.signedChannelDesc ? decodeURI(this.$route.query.signedChannelDesc) : '';
    this.taxCompanyName = this.$route.query.taxCompanyName || '';
  },
  methods: {
    //筛选查询
    screenList() {
      if (!WUYI.checkDate(this.searchOpts.beginDate, this.searchOpts.endDate)) return;
      this.searchCache = { ...this.searchOpts };
      WUYI.trackEvent(['_trackEvent', ymPageData[this.pageSource].title, ymPageData.searchText]);
      this.searchCache.endDate = this.searchCache.endDate + WUYI.time.oneday;
      this.currentPage = 1;
      this.ajaxRequest();
    },
    //导出
    exportList() {
      if (this.tableData.total == 0) {
        this.$message.warning('未查询到数据，请重新筛选');
        return;
      }
      this.dialogVisible = true;
    },
    ajaxRequest() {
      let options = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchCache };
      axios.post(api.walletMoneyQuery, options).then(res => {
        if (res.data.total == 0) {
          this.$message.warning('未查询到数据，请重新筛选');
        }
        this.tableData.total = res.data.total || 0;
        this.tableData.data = res.data.data || [];
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.ajaxRequest();
    },
    exportComfirm() {
      WUYI.trackEvent(['_trackEvent', ymPageData[this.pageSource].title, ymPageData.exportText]);
      var _data = { ...this.searchCache };
      _data.usercode = WUYI.currentData.user.usercode;

      axios.post(api.walletMoneyExport, _data).then(res => {
        this.dialogVisible = false;
        this.$message.success('提交成功，请稍后在“下载管理”中查看');
      });
    },
    viewReportTips() {
      WUYI.trackEvent(['_trackEvent', ymPageData[this.pageSource].title, ymPageData.exportSpecification]);
      window.open('./extend.html#/reportExplain/first');
    }
  }
};
</script>
